export default __webpack_public_path__ + "static/media/g2022-19.e7b94c7b.jpeg";